import { Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import MyModal from "../MyModal";

interface ReorderModalProps {
  onClose: () => void;
  onConfirm: () => void;
}

export default function ReorderModal({
  onClose,
  onConfirm,
}: ReorderModalProps) {
  const { t } = useTranslation();

  return (
    <MyModal
      title={t("banners.table.reorder")}
      modalChange={onClose}
      disableDivider
      maxWidth="32rem"
    >
      <Typography
        sx={{
          marginTop: 3,
        }}
      >
        {t("banners.modal.description")}
      </Typography>
      <Stack
        direction="row"
        sx={{
          alignItems: "flex-start",
          gap: 2,
          marginTop: 3,
        }}
      >
        <Button variant="contained" sx={{ width: "100px" }} onClick={onConfirm}>
          {t("button.Yes")}
        </Button>
        <Button
          variant="outlined"
          sx={{ width: "100px", color: "#00B0F0" }}
          onClick={onClose}
        >
          {t("button.No")}
        </Button>
      </Stack>
    </MyModal>
  );
}